import React from 'react';

const NewsFeedDoc = (props) => {
  return (
    <svg
      width={106}
      height={78}
      viewBox="0 0 106 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.50934 19.0882C1.22345 18.0213 1.85662 16.9246 2.92355 16.6387L40.0991 6.67756L51.3687 13.1841L64.4258 61.914C64.7117 62.981 64.0785 64.0776 63.0116 64.3635L18.8799 76.1886C17.813 76.4745 16.7163 75.8413 16.4304 74.7744L1.50934 19.0882Z"
        fill="#B1DAD7"
      />
      <path
        d="M20.9995 75.5V12L38.9995 6.49998L44.9995 69L20.9995 75.5Z"
        fill="#8BC4BF"
      />
      <path
        d="M14.9535 69.2625L16.4304 74.7744C16.7163 75.8413 17.813 76.4745 18.8799 76.1886L63.0116 64.3635C64.0785 64.0776 64.7117 62.981 64.4258 61.914L51.3687 13.1841L40.0991 6.67756L2.92355 16.6387C1.85662 16.9246 1.22345 18.0213 1.50934 19.0882L8.96987 46.9313L10.9644 54.375L11.9617 58.0969"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.0996 6.67758L51.3692 13.1841L42.4812 15.5656L40.0996 6.67758Z"
        fill="#7CC5BF"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M12.5081 31.694L46.2826 22.6441"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M14.6516 39.6932L48.4262 30.6433"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M16.7949 47.6925L50.5695 38.6426"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M18.9387 55.6917L52.7133 46.6418"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M21.0818 63.6909L54.8563 54.641"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M104.427 19.0882C104.713 18.0212 104.079 16.9246 103.012 16.6387L65.837 6.67753L54.5674 13.184L41.5102 61.914C41.2243 62.9809 41.8575 64.0776 42.9244 64.3635L87.0561 76.1885C88.1231 76.4744 89.2197 75.8413 89.5056 74.7743L104.427 19.0882Z"
        fill="#B1DAD7"
      />
      <path
        d="M77.3911 9.77354C56.1277 26.5578 56.1162 55.9906 58.7684 68.6089L40.9923 63.8458L54.5671 13.184L65.8367 6.67753L77.3911 9.77354Z"
        fill="#B1DAD7"
      />
      <path
        d="M102.95 24.6001L104.427 19.0882C104.713 18.0212 104.079 16.9246 103.012 16.6387L65.837 6.67753L54.5674 13.184L41.5102 61.914C41.2243 62.9809 41.8575 64.0776 42.9244 64.3635L87.0561 76.1885C88.1231 76.4744 89.2197 75.8413 89.5056 74.7743L96.9662 46.9313L98.9607 39.4875L99.958 35.7657"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.8367 6.67753L54.5671 13.184L63.4551 15.5656L65.8367 6.67753Z"
        fill="#7CC5BF"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M93.4277 31.694L59.6532 22.6441"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M91.2847 39.6932L57.5101 30.6433"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M89.1411 47.6924L55.3666 38.6426"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M86.9976 55.6917L53.223 46.6418"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M84.8545 63.6909L51.0799 54.641"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M26 3.99998C26 2.89541 26.8954 1.99998 28 1.99998H70L80 12V67C80 68.1046 79.1046 69 78 69H28C26.8954 69 26 68.1046 26 67V3.99998Z"
        fill="#CFEDEB"
      />
      <path
        d="M57 1.99998C74.6 25.6 66.3333 56.5 60 69H80V12L70 1.99998H57Z"
        fill="#B1DAD7"
      />
      <path
        d="M26 32.125V18.75V3.99999C26 2.89542 26.8954 1.99998 28 1.99998H70L80 12V67C80 68.1046 79.1046 69 78 69H28C26.8954 69 26 68.1046 26 67V52.25V40.875"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70 1.99998L80 12H70V1.99998Z"
        fill="#7CC5BF"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M34 20.5H72"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M34 29.5H72"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M34 38.5H72"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M34 47.5H72"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M34 56.5H72"
        stroke="#071C3E"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default NewsFeedDoc;
